export const enum ResStatus {
  RES_STANDBY = 0, // 서비스점검중
  RES_SUCCESS = 200,
  RES_FAIL = 400, // FAIL (잘못된 요청)

  RES_UNAUTHORIZED = 401, // 권한이 없음 (인증 실패)
  RES_FORBIDDEN = 403, // 서버가 요청 거부 (인가 실패)
  RES_NOTFOUND = 404, // 찾을 수 없음
  RES_INTERNAL_SERVER_ERROR = 500, // 서버 내부 오류
  RES_NOT_IMPLEMENT = 501, // 구현되지 않음 (서버에 요청을 수행할 수 있는 기능이 없음)
  RES_NOT_SERVICE = 900, // 서비스 중지중

  RES_SQLEXCEPTION = 1000,
  RES_PG_FAIL = 1006,
  RES_ALREADY_ACCOUNT = 9100, // SQL Exception
  RES_NOTFOUND_ACCOUNT = 9101, // NOT_FOUND_ACCOUNT
  RES_BLOCKED_ACCOUNT = 9102, // 차단된 계정
  RES_STOPED_ACCOUNT = 9103, // 정지된 계정
  RES_SNS_AUTHENTICATION_FAILED = 9105,
  RES_SNS_CHANNEL_FAILED = 9106,
  RES_SNS_REQUEST_FAILED = 9108,
}

export const enum BasketListStatus {
  BLS_DEFAULT = 0,
  BLS_ESTIMATE = 100,
  BLS_ORDER = 101,
}

export const enum OrderStatus {
  COMPLETE_PAYMENT = 1, // 결제완료, 주문완료-수거대기, 픽업을 준비중입니다, 주문취소가능, 픽업일정 수정가능
  CANCEL_ORDER = 2, // 주문취소
  PICKUP = 3, // 픽업중
  PICKUP_COMPLETE = 4, // 픽업완료, 수거완료
  MINTING = 5, // 민트중, 작업시작
  MINT_COMPLETE = 6, // 민트완료, 작업종료
  SHIPPING = 7, // 배송중, 출고->배송시작
  DELIVERY_COMPLETE = 8, // 배송완료
  REJECT_ORDER = 9,
  REQUESTING = 100, // 견적요청중
  WAITING_ORDER = 101, // 주문대기중
  ETC = 200,
}

export const enum DeliveryStatus {
  BEFORE = 0,
  DOIT = 1,
  ING = 2,
  COMPLETE = 3,
}

export const enum DeliveryMethod {
  BUTLER = 0,
  COURIER = 1,
}

export const enum UNTACT {
  YES = 0, // 대면
  NO = 1, // 비대면
}

// export const enum ChannelType { //app/slp/apt/lpm/off
//     APP = "app",
//     SLP = "slp",
//     APT = "apt",
//     LPM = "lpm",
//     off = "off",
// }

// export const Channel = ["app", "slp", "apt", "lpm", "off"]; //app/slp/apt/lpm/off
